export default class DtoIndustrialSite {
	constructor(obj) {
		this.id = obj.id
		this.activity = obj.activity
		this.state = obj.state_of_knowledge
		this.familyCode = obj.industrialsitefamily_code
		this.sevesoCode = obj.industrialsiteseveso_code
		this.activityCode = obj.industrialsiteactivity_code
	}
}



// WEBPACK FOOTER //
// ./src/station/dto/DtoIndustrialSite.js